import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Marquee from "./components/Marquee";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Doctors from "./pages/Doctors";
import DoctorProfile from "./pages/DoctorProfile";
import Consultation from "./pages/Consultation";
import Services from "./pages/Services";
import Wellness from "./pages/Wellness";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import "./App.css";

function Layout({ children }) {
  return (
    <>
      <Marquee />
      <Navbar />
      {children}
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function AdminLayout({ children }) {
  return <>{children}</>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/doctors"
            element={
              <Layout>
                <Doctors />
              </Layout>
            }
          />
          <Route
            path="/doctors/:id"
            element={
              <Layout>
                <DoctorProfile />
              </Layout>
            }
          />
          <Route
            path="/consultation"
            element={
              <Layout>
                <Consultation />
              </Layout>
            }
          />
          <Route
            path="/services"
            element={
              <Layout>
                <Services />
              </Layout>
            }
          />
          <Route
            path="/wellness"
            element={
              <Layout>
                <Wellness />
              </Layout>
            }
          />
          <Route
            path="/reviews"
            element={
              <Layout>
                <Reviews />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <Contact />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
